import React from "react";
import ReactDOM from "react-dom";

import "whatwg-fetch";

import App from "./App";

import evaManifest from "./eva-manifest.json";

const evaContainer =
  document.getElementById(evaManifest?.containerId) || document.body;

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  evaContainer
);
